import Bookings from '@/admin/pages/orders/orders';
import { ordersQuery } from '@/admin/queries/orders';
import { parseDate, parseEnum, sanitizeSearchParams } from '@/lib/utils';
import { createFileRoute } from '@tanstack/react-router';

const BOOKING_STATUSES = [
	'pending',
	'confirmed',
	'completed',
	'cancelled',
] as const;

export const Route = createFileRoute('/_app/orders/')({
	validateSearch: (search) =>
		sanitizeSearchParams(search, (r) => ({
			status: parseEnum<(typeof BOOKING_STATUSES)[number]>(
				r.status,
				BOOKING_STATUSES,
			),
			from_date: parseDate(r.from_date),
			to_date: parseDate(r.to_date),
		})),

	loaderDeps: ({ search }) => search,

	loader: ({ context, deps }) =>
		context.queryClient.ensureQueryData(
			ordersQuery({
				page: deps.page,
				per_page: deps.per_page,
				search: deps.search || undefined,
				status: deps.status,
				from_date: deps.from_date,
				to_date: deps.to_date,
			}),
		),

	component: Bookings,
});
